import React, { useEffect, useState } from "react";
import * as _ from "lodash"
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { Button, Spinner } from "react-bootstrap";
import Switch from "react-switch";
import useReactRouter from "use-react-router"
import { useSubscription, useLazyQuery } from "@apollo/client";
import { CANCELLED, COLOR_APP, COMPLETED } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore, faVideoSlash, faVolumeHigh, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
import useStateRef from "react-usestateref";
import { useToasts } from "react-toast-notifications";
import CreateOrderModal from "./CreateOrderModal";
import { LiveErrorScreen } from "./LiveErrorScreen";
import moment from "moment";
import { useLocation } from 'react-router-dom';
import { SUBSCRIPTION_COMMENT } from "../../../graphql/liveComment/subscription";
import { GET_POST_COMMENT, GET_POST_COMMENTS } from "../../../graphql/postComment/query";
import axios from "axios"

// style
function CommentLiveScreen({ endLiveLoading, endLive, liveData, onPlayNoProduct, playNoProduct, fetchLiveStocks, fetchLiveOrders, liveStocks, updateOrder, updateLiveStock, orders }) {
//TODO For create order v2 
// function CommentLiveScreen({ endLiveLoading, endLive, liveData, onPlayNoProduct, playNoProduct, fetchLiveStocks, fetchLiveOrders, liveStocks, updateOrders, orders }) {
    const { height, width } = useWindowDimensions();
    const { addToast } = useToasts()
    const { history, match } = useReactRouter()
    const location = useLocation();
    // const { match } = useReactRouter()

    // State
    const [showCreateOrderModal, setShowCreateOrderModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState();
    const [fbVideoCreatedAt, setFbVideoCreatedAt] = useState();
    const [isLoadingComment, setIsLoadingComment] = useState(false)

    var [liveComments, setLiveComments, liveCommentsRef] = useStateRef([]);
    const lastFBFetchTimeRef = React.useRef(0);
    const fbFetchTimeoutRef = React.useRef(null);

    const [getPostComments, { data: serverCommentDataV1 }] = useLazyQuery(GET_POST_COMMENTS, {
        fetchPolicy: "network-only"
    });

    const [getPostComment, { data: serverCommentDataOne }] = useLazyQuery(GET_POST_COMMENT, {
        fetchPolicy: "network-only"
    });


    const _fbLiveId = location.state?.fbLiveId ?? liveData?.live?.fbLiveId;
    const { data: commentData } = useSubscription(SUBSCRIPTION_COMMENT, {
        variables: {
            fbLiveId: _fbLiveId || ''
        }
    });

    const fetchFacebookComments = async (live, { limit = 100000 } = {}) => {
        const liveVideoId = live?.fbLiveId;
        const accessToken = live?.pageAccessToken;
        if (!liveVideoId || !accessToken) {
            throw new Error("Missing Facebook Video ID or Access Token");
        }

        const url = `https://graph.facebook.com/v21.0/${liveVideoId}/comments?fields=created_time,message,from{id,name,picture},can_reply_privately&limit=${limit}&order=reverse_chronological&access_token=${accessToken}`;
        const response = await axios.get(url);
        return response?.data?.data ?? [];
    };
    // 
    // useEffect
    useEffect(() => {
        if (liveData?.live) {
            if ([COMPLETED, CANCELLED].includes(liveData?.live?.status)) return history.goBack();
            selectLiveVideos(liveData?.live)
        }
    }, [liveData])

    useEffect(() => {
        const handleSubscriptionComment = async () => {
            if (!commentData) return;

            console.log("Subscription Comment Data Received:", commentData);
            const subscriptionComment = commentData?.onCommentCreated;
            if (!subscriptionComment) return;

            const normalizeComment = (comment) => {
                if (!comment || typeof comment !== "object") return null;
                const id = comment?.id ?? comment?.commentId ?? comment?.comment_id;
                if (!id) return null;
                const from =
                    comment?.from ??
                    (comment?.name || comment?.psid ? { id: comment?.psid, name: comment?.name } : undefined);
                return { ...comment, id, from };
            };

            const prependIfMissing = (comment) => {
                const normalized = normalizeComment(comment);
                if (!normalized) return;
                const existing = liveCommentsRef.current ?? [];
                const matchedIdx = existing.findIndex((c) => (c?.id ?? c?.commentId) === normalized.id);
                // If it exists, just update it in case we have more info, else prepend
                if (matchedIdx > -1) {
                    const next = [...existing];
                    next[matchedIdx] = { ...next[matchedIdx], ...normalized };
                    setLiveComments(next);
                } else {
                    setLiveComments([normalized, ...existing]);
                }
            };

            // 1. Show comment IMMEDIATELY (even without picture)
            prependIfMissing(subscriptionComment);

            // 2. Schedule Facebook API call to get picture (Throttled 5 seconds)
            const scheduleFBFetch = () => {
                if (fbFetchTimeoutRef.current) return; // Already scheduled

                const now = Date.now();
                const waitTime = Math.max(0, 5000 - (now - lastFBFetchTimeRef.current));

                fbFetchTimeoutRef.current = setTimeout(async () => {
                    fbFetchTimeoutRef.current = null;
                    lastFBFetchTimeRef.current = Date.now();
                    
                    try {
                        console.log("Throttled poll: Fetching latest profile pictures from Facebook...");
                        const latestFromFB = await fetchFacebookComments(liveData?.live, { limit: 20 });
                        
                        const existing = liveCommentsRef.current ?? [];
                        const next = existing.map(localC => {
                            const foundOnFB = latestFromFB.find(fbC => (fbC.id === localC.id || fbC.commentId === localC.id));
                            if (foundOnFB) {
                                return { ...localC, ...foundOnFB };
                            }
                            return localC;
                        });
                        setLiveComments(next);
                    } catch (err) {
                        console.log("Throttled FB fetch error:", err);
                    }
                }, waitTime);
            };

            scheduleFBFetch();
        };

        handleSubscriptionComment();
    }, [commentData, liveData?.live?.fbLiveId, liveData?.live?.pageAccessToken]);

    // Cleanup timeouts on unmount
    useEffect(() => {
        return () => {
            if (fbFetchTimeoutRef.current) clearTimeout(fbFetchTimeoutRef.current);
        };
    }, []);

    useEffect(() => {
        if (serverCommentDataOne?.postComment) {
            const comment = serverCommentDataOne.postComment;
            const normalized = {
                ...comment,
                id: comment.commentId ?? comment.id,
                from: {
                    id: comment.psid,
                    name: comment.name
                }
            };
            const existing = liveCommentsRef.current ?? [];
            const matchedIdx = existing.findIndex((c) => (c?.id ?? c?.commentId) === normalized.id);
            if (matchedIdx > -1) {
                const next = [...existing];
                next[matchedIdx] = { ...next[matchedIdx], ...normalized };
                setLiveComments(next);
            } else {
                setLiveComments([normalized, ...existing]);
            }
        }
    }, [serverCommentDataOne]);

    // useEffect(() => {
    //     if (liveData?.live?.id) {
    //         fetchServerComments(liveData.live);
    //     }
    // }, [liveData])



    useEffect(() => {
        if (serverCommentDataV1?.postComments?.data) {
            const mappedComments = serverCommentDataV1.postComments.data.map(comment => ({
                ...comment,
                id: comment.commentId,
                from: {
                    id: comment.psid,
                    name: comment.name,
                }
            }));
            // Only set if not already set by a successful FB fetch or if we want to ensure latest
            setLiveComments(mappedComments);
        }
    }, [serverCommentDataV1]);

    const fetchServerComments = async (live) => {
        try {
            const SHOP_ID = localStorage.getItem("SHOP");
            const liveId = live?.id;
            if (liveId) {
                const variables = {
                    where: {
                        post: liveId
                    },
                    orderBy: "createdAt_DESC",
                    skip: null,
                    limit: 100000
                };
                return getPostComments({ variables });
            }
        } catch (error) {
            console.log("Error fetching server comments:", error);
        }
    }

    const updateCommentStatus = (commentId) => {
        const _newLiveComments = liveCommentsRef.current.map(c => {
            if (c.id === commentId || c.commentId === commentId) {
                return { ...c, isReply: true, can_reply_privately: false };
            }
            return c;
        });
        setLiveComments(_newLiveComments);
    }

    const selectLiveVideos = async (live) => {
        setIsLoadingComment(true);
        try {
            console.log("Attempting to load comments from Facebook Graph API (v21.0)...");
            const fbComments = await fetchFacebookComments(live, { limit: 100000 });
            
            if (fbComments && fbComments.length > 0) {
                setLiveComments(fbComments);
                console.log(`Successfully loaded ${fbComments.length} comments from Facebook API.`);
            } else {
                console.log("Facebook API returned no data, falling back to database query...");
                fetchServerComments(live);
            }
        } catch (error) {
            console.log("Facebook Graph API error, falling back to database V1:", error);
            fetchServerComments(live);
        } finally {
            setIsLoadingComment(false);
        }
    }


    return (
        <div style={{ overflow: 'scroll', padding: 5, background: '#F5F5FA', border: '1px solid #F5F5FA', borderRadius: 10, height: width > 700 ? "82vh" : "70vh" }}>
            {
                width > 700 && <div style={{ background: "#FFF", borderRadius: 6, margin: 2, padding: 5, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ margin: "10px 2px", padding: "6px 4px", fontSize: 16, fontWeight: 'bold', background: "#F5F5FA", borderRadius: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap' }}>ຫົວຂໍ້ໄລຟ: {liveData?.live?.description}</div>
                    {fbVideoCreatedAt && <pre style={{ fontSize: 14, margin: 0, padding: 0 }}>ເວລາ: {moment((new Date(Date.parse(fbVideoCreatedAt))).toString()).format('DD/MM/YYYY HH:mm A')}</pre>}
                    

                    <div style={{ display: 'flex', margin: '10px 0px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FontAwesomeIcon className="mr-2" color={COLOR_APP} icon={playNoProduct ? faVolumeHigh : faVolumeMute} />
                                ປິດ/ເປີດສຽງ
                            </div>
                            <div>
                                <Switch
                                    checked={playNoProduct}
                                    onChange={() => onPlayNoProduct()}
                                    onColor="#4CAF50"
                                    onHandleColor="#2E7D32"
                                    offColor="#ff0000"
                                    offHandleColor="#b71c1c"
                                    handleDiameter={25}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={15}
                                    width={40}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </div>
                        </div>

                        <div>
                            <Button className="btn btn-danger" style={{ borderRadius: 10, padding: '5px 10px' }}
                                onClick={() => endLive()}
                            >
                                {endLiveLoading ? <Spinner size="sm" animation="border" /> : <FontAwesomeIcon icon={faVideoSlash} />}
                                ສິ້ນສຸດໄລຟ
                            </Button>
                        </div>
                    </div>
                </div>
            }

            <div style={{ color: COLOR_APP, marginTop: 10, fontSize: 14, fontWeight: 'bold' }}>
                {/* <Button size="sm" style={{ background: LINEAR_GRADIENT_BG, color: "#ffffff", border:'none' }} onClick={handleRefreshComment} disabled={isLoadingComment ? true : false} > {isLoadingComment ? (<Spinner size="sm" />) : (<MdOutlineRefresh />)} </Button> */}
                Comment ລູກຄ້າ {liveComments?.length ?? 0} ລາຍການ</div>
            <div style={{ overflow: 'scroll', background: "#FFF", borderRadius: 6, margin: 2, padding: 5, display: 'flex', flexDirection: 'column' }}>
                {liveComments?.map((fbComment, index) => {
                    const isOrdered = orders?.some(order => (order.commentId && fbComment.id && order.commentId === fbComment.id) || (order.commentId && fbComment.commentId && order.commentId === fbComment.commentId));
                    const isReplied = (typeof fbComment?.can_reply_privately === 'boolean' && !fbComment?.can_reply_privately) || fbComment?.isReply || fbComment?.isCreated || isOrdered;

                    return (
                    <div key={index} style={{ display: 'flex', margin: '10px 0px', justifyContent: 'space-between', gap: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ fontSize: 12, display: 'flex', justifyContent: 'start', alignItems: 'start' }}>
                                {fbComment?.from?.picture ? (
                                    <img className="mr-2" src={fbComment?.from?.picture?.data?.url} alt="fb"
                                        style={{ width: 30, height: 30, borderRadius: 50 }}
                                    />
                                ) : (
                                <img className="mr-2" src="https://img.freepik.com/premium-vector/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector-illustration_561158-3383.jpg" alt="fb"
                                    style={{ width: 30, height: 30, borderRadius: 50 }}
                                />
                                )}  
                                <div style={{ padding: 5, borderRadius: 10, 
                                    background: isReplied ? 'green' : '#f2f2f2' }}>
                                    <p style={{ fontSize: 14, fontWeight: 'bold', color: isReplied ? 'white' : 'black' }}>{fbComment?.from?.name ?? fbComment?.name}</p>
                                    <p style={{ fontSize: 13, marginTop: '-1.3em', marginBottom: '-.008px', color: isReplied ? 'white' : 'black' }}>{fbComment?.message}
                                        {isReplied ? ' ✅' : ' ❓'}
                                    </p>
                                </div>

                            </div>
                        </div>

                        <div className="ml-2">
                            <Button style={{ fontSize: 12, borderRadius: 6, borderColor: "#5357B6", color: "#5357B6", padding: 2, background: 'transparent' }}
                                // disabled={!fbComment?.can_reply_privately}
                                onClick={() => {
                                    setShowCreateOrderModal(true);
                                    setSelectedComment(fbComment)
                                }}>
                                <FontAwesomeIcon icon={faStore} className="mr-2" />ສ້າງອໍເດີ້
                            </Button>
                        </div>
                    </div>
                )})}
            </div>
            <CreateOrderModal updateOrder={updateOrder} updateLiveStock={updateLiveStock} updateCommentStatus={updateCommentStatus} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveId={liveData?.live?.id} showCreateOrderModal={showCreateOrderModal} setShowCreateOrderModal={setShowCreateOrderModal} liveStocks={liveStocks} selectedComment={selectedComment} />
            {/*             <CreateOrderModal updateOrder={updateOrder} updateLiveStock={updateLiveStock} fetchLiveStocks={fetchLiveStocks} fetchLiveOrders={fetchLiveOrders} liveId={liveData?.live?.id} showCreateOrderModal={showCreateOrderModal} setShowCreateOrderModal={setShowCreateOrderModal} liveStocks={liveStocks} selectedComment={selectedComment} /> */}
            {/* //TODO For create order V2*/}
            {/* <CreateOrderModal
                fetchLiveStocks={fetchLiveStocks} 
                fetchLiveOrders={fetchLiveOrders} 
                showCreateOrderModal={showCreateOrderModal} 
                setShowCreateOrderModal={setShowCreateOrderModal} 
                selectedComment={selectedComment}
                liveStocks={liveStocks} 
                liveData={liveData?.live}
                updateOrders={updateOrders}
            /> */}
            {liveData && <LiveErrorScreen liveData={liveData?.live} playNoProduct={playNoProduct} />}
        </div>
    );
}

export default CommentLiveScreen;
